module.exports = __webpack_public_path__ + "img/back_bottom.b0316762.svg";